import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'

export const fetchItems = (params = {}) => async (dispatch) => {
  dispatch({ type: ActionTypes.S3ASSETLIST_FETCHITEMS_LOAD })
  try {
    const {
      current = 1,
      pageSize = 50,
      search,
      folder,
    } = params
    const query = {
      $limit: pageSize,
      search: search || undefined,
      folder: folder || undefined,
    }
    const result = await api.get('s3-assets', query)
    const {
      data: items,
      total,
      currentFolder,
    } = result
    dispatch({
      type: ActionTypes.S3ASSETLIST_FETCHITEMS_SUCCEED,
      items,
      total,
      currentFolder,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.S3ASSETLIST_FETCHITEMS_FAIL,
      fetchItemsError: error.message,
    })
  }
}

export const uploadItem = (file, folder = '') => async (dispatch) => {
  dispatch({ type: ActionTypes.S3ASSETLIST_UPLOADITEM_LOAD })
  try {
    const result = await api.uploadS3Asset(file, folder)
    dispatch({
      type: ActionTypes.S3ASSETLIST_UPLOADITEM_SUCCEED,
      item: result,
    })
    return result
  } catch (error) {
    dispatch({
      type: ActionTypes.S3ASSETLIST_UPLOADITEM_FAIL,
      uploadItemError: error.message,
    })
    throw error
  }
}

export const deleteItem = (key) => async (dispatch) => {
  dispatch({ type: ActionTypes.S3ASSETLIST_DELETEITEM_LOAD })
  try {
    // Use query param instead of path param to handle slashes in key
    await api.delete(`s3-assets?key=${encodeURIComponent(key)}`)
    dispatch({
      type: ActionTypes.S3ASSETLIST_DELETEITEM_SUCCEED,
      key,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.S3ASSETLIST_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.S3ASSETLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.S3ASSETLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.S3ASSETLIST_SEARCHTABLE_EDIT,
    search,
  })
}

export const createFolder = (folderName, parentFolder = '') => async (dispatch) => {
  dispatch({ type: ActionTypes.S3ASSETLIST_CREATEFOLDER_LOAD })
  try {
    const fullPath = parentFolder ? `${parentFolder}/${folderName}` : folderName
    const result = await api.createS3Folder(fullPath)
    dispatch({
      type: ActionTypes.S3ASSETLIST_CREATEFOLDER_SUCCEED,
      folder: result,
    })
    return result
  } catch (error) {
    dispatch({
      type: ActionTypes.S3ASSETLIST_CREATEFOLDER_FAIL,
      createFolderError: error.message,
    })
    throw error
  }
}

